module.exports = __webpack_public_path__ + "img/dcfl04.f4041c72.png";